import { THEME_COLORS } from "src/theme-mui/tokens/colors";

export const palette = {
    // The primary and secondary palette are not intended to be used directly in components.
    // However, in case a component is mistakenly not replaced with specific colors,
    // it will fall back to these default values.
    primary: {
        light: THEME_COLORS.green[400],
        main: THEME_COLORS.green[600],
        dark: THEME_COLORS.green[800],
        contrastText: "#fff",
    },
    secondary: {
        light: THEME_COLORS.gray[300],
        main: THEME_COLORS.gray[600],
        dark: THEME_COLORS.gray[800],
        contrastText: "#fff",
    },
    error: {
        light: THEME_COLORS.red[300],
        main: THEME_COLORS.red[600],
        dark: THEME_COLORS.red[800],
        contrastText: "#fff",
    },
    warning: {
        light: THEME_COLORS.orange[400],
        main: THEME_COLORS.orange[600],
        dark: THEME_COLORS.orange[800],
        contrastText: "#000",
    },
    info: {
        light: THEME_COLORS.sky[400],
        main: THEME_COLORS.sky[700],
        dark: THEME_COLORS.sky[900],
        contrastText: "#000",
    },
    success: {
        light: THEME_COLORS.teal[400],
        main: THEME_COLORS.teal[600],
        dark: THEME_COLORS.teal[800],
        contrastText: "#000",
    },
    background: {
        default: THEME_COLORS.gray[50],
        paper: THEME_COLORS.gray[100],
    },
    text: {
        primary: THEME_COLORS.gray[800],
        secondary: THEME_COLORS.gray[600],
    },
    ...THEME_COLORS,
};
